import React from 'react';
import { ShoppingBag, MousePointer2, CheckCircle2 } from 'lucide-react';
import './OrderProcess.css';

const OrderProcess = () => {
    const steps = [
        {
            icon: <ShoppingBag size={40} />,
            title: "Choisissez vos douceurs",
            description: "Naviguez à travers nos collections d'entremets et de pâtisseries artisanales."
        },
        {
            icon: <MousePointer2 size={40} />,
            title: "Commandez en ligne",
            description: "Sélectionnez votre créneau de retrait et validez votre panier en quelques clics."
        },
        {
            icon: <CheckCircle2 size={40} />,
            title: "Retirez en boutique",
            description: "Venez récupérer vos créations directement dans notre boutique à Albi."
        }
    ];

    return (
        <section className="process-section">
            <div className="container">
                <div className="process-header text-center">
                    <h2 className="section-title">L'Expérience Click & Collect</h2>
                    <p className="section-intro">Savourez la simplicité d'une pâtisserie en ligne, l'exigence du goût en plus.</p>
                </div>

                <div className="process-steps">
                    {steps.map((step, index) => (
                        <div key={index} className="step-item">
                            <div className="step-number">{index + 1}</div>
                            <div className="step-icon-wrapper">
                                {step.icon}
                            </div>
                            <h3>{step.title}</h3>
                            <p>{step.description}</p>
                            {index < steps.length - 1 && <div className="step-line"></div>}
                        </div>
                    ))}
                </div>

                <div className="process-action text-center" style={{ marginTop: '50px' }}>
                    <a href="/produits" className="btn btn-primary btn-large">
                        Commander maintenant
                    </a>
                </div>
            </div>
        </section>
    );
};

export default OrderProcess;
